// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as PlayDefault } from '../../../assets/icons/default/media_devices/play.svg?react';
import { ReactComponent as PlaySolid } from '../../../assets/icons/solid/media_devices/PLAY.svg?react';
import { createIcons } from '../../Icon';
const PlayIcon = /* @__PURE__ */ createIcons('Play', {
    default: PlayDefault,
    solid: PlaySolid
});
PlayIcon.supportedTypes = ['default', 'solid'];
PlayIcon.category = 'media_devices';
export default PlayIcon;
